import { FlightClassTypes } from './flight-class-types';

export enum FlightClass {
  CHEAPER = 'CHEAPER',
  EXECUTIVE = 'EXECUTIVE',
  FIRST_CLASS = 'FIRST_CLASS',
  PREMIUM = 'PREMIUM'
}

export const SearchFlightClassByTypes = {
  [FlightClassTypes.ECONOMY]: FlightClass.CHEAPER,
  [FlightClassTypes.BUSINESS]: FlightClass.EXECUTIVE,
  [FlightClassTypes.FIRST]: FlightClass.FIRST_CLASS,
  [FlightClassTypes.PREMIUMECONOMY]: FlightClass.PREMIUM
};
